module.exports = __webpack_public_path__ + "img/mg.7a54f12d.svg";